import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Spinner from "./layout/Spinner";
import { connect } from "react-redux";
import { setUserData } from "../actions/auth";

const Dashboard = ({ user, setUserData }) => {
  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (user) {
      setUserData(user);
    }
    // setUserData(user);
    console.log(setUserData);
    console.log("user function:", user);
  }, []);

  // return user.isAuthenticated ? (
  //   <Spinner />
  // ) : (
  return (
    <div>
      <h1 className='large text-primary text-center my-2'>My Dashboard</h1>
      <div className='grid-2'>
        <div>
          <p className='lead'>
            <i className='fas fa-user'> Hello {user && user.email}</i>
          </p>
          <h2 style={{ width: "80px", borderBottom: "1px solid #e5e5e5" }}>
            Account
          </h2>
          <ul>
            <li>
              <Link
                to='/dashboard'
                className='btn btn-light'
                style={{ paddingLeft: "0", background: "#fff" }}
              >
                Account Dashboard
              </Link>
            </li>
            <li>
              <Link
                to='/my-listings'
                className='btn btn-light'
                style={{ paddingLeft: "0", background: "#fff" }}
              >
                My Listings
              </Link>
            </li>
          </ul>
        </div>
        <div>
          <h2 style={{ width: "100px", borderBottom: "1px solid #e5e5e5" }}>
            ADDRESS
          </h2>

          <p>Name: John Doe</p>
          <p>Street Address: 410 Lambda Street</p>
          <p>Apt: 1</p>
          <p>Zip Code: 07051</p>
          <p>City: Lambda City</p>
          <p>Country: United States</p>
          <Link className='btn btn-light my-1' to='/edit-address'>
            Edit Address
          </Link>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  // auth: state.auth,
  user: state.auth.user,
  // isAuthenticated: state.auth.user.isAuthenticated,
});
export default connect(mapStateToProps, { setUserData })(Dashboard);
